import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import { When } from 'UI/components/atoms';

export const MenuItems = React.forwardRef(({ menuItems }, ref) => {
  return menuItems.map(menuItem => (
    <When key={menuItem.key} condition={menuItem.shouldRender}>
      <MenuItem onClick={menuItem.onClick} className={menuItem.className} ref={ref}>
        {menuItem.children}
      </MenuItem>
    </When>
  ));
});
